import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	insertVariableTriggerNonFinal: {
		id: 'language-settings.generic-panel.notification-editor.editor-dropdown.insert-variable-trigger-non-final',
		defaultMessage: 'Insert variable',
		description: 'Label for trigger of the dropdown to insert variables into the field',
	},
	hiddenFromEmailContentNonFinal: {
		id: 'language-settings.generic-panel.notification-editor.editor-dropdown.hidden-from-email-content-non-final',
		defaultMessage: 'Hidden from email content',
		description: 'Tooltip message for privacy unsafe variable icon',
	},
});
